import { consoleLog } from "../../utils/log-utils";
import { TAG_API_PATH } from "../config/apiPaths";
import { getRequest } from "./config/GetRequest";
import { postRequest } from "./config/PostRequest";

export const listRequest = () => async () => {
  try {
    let result = await getRequest(TAG_API_PATH.LIST_PATH, null, false);
    return result;
  } catch (error) {
    consoleLog("",error);
    // TODO Handle Error
  }
};

export const storeTagListRequest = (data) => async () => {
  try {
    let result = await getRequest(
      `${TAG_API_PATH.STORE_TAG_LIST_PATH}?storeId=${data.storeId}`,
      null,
      false
    );
    return result;
  } catch (error) {
    consoleLog("",error);
    // TODO Handle Error
  }
};

export const createUpdateRequest = (data) => async () => {
  try {
    let result = await postRequest(
      TAG_API_PATH.CREATE_UPDATE_PATH,
      data,
      false
    );
    return result;
  } catch (error) {
    // TODO Handle Error
    return error;
  }
};

export const updateStoreTagsRequest = (data) => async () => {
  try {
    let result = await postRequest(TAG_API_PATH.STORE_TAGS_UPDATE, data, false);
    return result;
  } catch (error) {
    // TODO Handle Error
    return error;
  }
};
